import Vue from 'vue'
import App from './App.vue'
import router from './router'
import AOS from 'aos'
import 'aos/dist/aos.css'

Vue.config.productionTip = false

// 初始化AOS
AOS.init({
  duration: 800,
  easing: 'ease-in-out',
  once: true
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')